export default __webpack_public_path__ + "static/media/male-tourist-backpack-walking-isolated-white-background-35845436.54d26710.jpg";